import axios from 'axios'
import Storage from '@/commons/storage';
import Message from "@/components/message";

// create an axios instance
const service = axios.create({
    //baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
    baseURL: process.env.VUE_APP_APIS,
    headers: {
        'X-Requested-With': 'XMLHttpRequest'
    },
    withCredentials: false, // send cookies when cross-domain requests
    timeout: 30000 // request timeout
})

// request interceptor
service.interceptors.request.use(
    config => {
        // do something before request is sent
        if (Storage.get("_wit_acis_token")) {
            // let each request carry token
            // ['X-Token'] is a custom headers key
            // please modify it according to the actual situation
            config.headers['X-Token'] = "1b0679be72ad976ad5d491ad57a5eec0";
            config.headers['Authorization'] = 'Bearer ' + Storage.get("_wit_acis_token");
        }
        return config
    },
    error => {
        // do something with request error
        Message.toast(error || 'Error');// for debug
        return Promise.reject(error);
    }
)

// response interceptor
service.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    response => {
        let res = response.data
        let header = response.headers['content-disposition'];
        if (header != undefined && header.split(';')[0] == 'attachment') {
            res = response;
        }
        // if the custom code is not 200, it is judged as an error.
        if (response.status !== 200) {
            Message.toast(res.message || 'Error');
            return Promise.reject(new Error(res.message || 'Error'))
        } else {
            !(!res?.meta?.success && res?.meta?.message == "specter_authorize_exception") || Message.confirm("对不起，您的登录信息过期无效请重新登录！", () => {
                Storage.clear(); //清除所有缓存
                window.location.href = "#/login"
            });
            return Promise.resolve(res)
        }
    },
    error => {
        window.console.log('err' + error) // for debug
        Message.toast(error.message || 'Error');
        return Promise.reject(error)
    }
);



const Request = {};
/**
 * http数据请求
 * @param {string} url 请求地址
 * @param {object} data 请求数据
 * @param {string} method 请求方法 GET/POST
 * @param {object} headers 请求头部 
 * @return {object} 返回请求Promise对象
 */
Request.http = (url, data = {}, method = 'GET', headers = { 'content-type': 'application/x-www-form-urlencoded' }, responseType = null) => {
    if (headers['content-type'] === 'application/x-www-form-urlencoded') {
        return service({ url: url, params: data, method: method, headers: headers, responseType: responseType });
    } else {
        return service({ url: url, data: data, method: method, headers: headers, responseType: responseType });
    }
}
/**
 * 用GET提交表单FORM方式请求数据
 * @param {string} url 请求地址
 * @param {object} data 请求数据
 * @return {object} 返回请求Promise对象
 */
Request.getForm = (url, data = {}) => {
    return Request.http(url, data);
}
/**
 * 用POST提交表单FORM方式请求数据
 * @param {string} url 请求地址
 * @param {object} data 请求数据
 * @return {object} 返回请求Promise对象
 */
Request.postForm = (url, data = {}) => {
    return Request.http(url, data, 'POST');
}
/**
 * 用POST提交JSON方式请求数据
 * @param {string} url 请求地址
 * @param {object} data 请求数据
 * @return {object} 返回请求Promise对象
 */
Request.getJson = (url, data = {}) => {
    return Request.http(url, data, 'POST', { 'content-type': 'application/json' });
}
/**
 * 用POST提交JSON方式请求数据
 * @param {string} url 请求地址
 * @param {object} data 请求数据
 * @return {object} 返回请求Promise对象
 */
Request.postJson = (url, data = {}) => {
    return Request.http(url, data, 'POST', { 'content-type': 'application/json' });
}
/**
 * 用POST提交上传文件等
 * @param {string} url 请求地址
 * @param {object} data 请求数据
 * @return {object} 返回请求Promise对象
 */
Request.imp = (url, data = {}) => {
    return Request.http(url, data, 'POST', { 'Content-Type': 'multipart/form-data' });
}
/**
 * 用POST提交下载文件等
 * @param {string} url 请求地址
 * @param {object} data 请求数据
 * @return {object} 返回请求Promise对象
 */
Request.exp = (url, data = {}) => {
    return Request.http(url, data, 'POST', { 'content-Type': 'application/json' }, 'blob');
}

export default Request;
